// Contenido único de las landings SEO de permisos (Fase 1)
// Precios: siempre "solicita presupuesto" (decisión del cliente)

export const PERMIT_LANDINGS = {
  "carnet-coche-vigo": {
    title: "Carnet de Coche en Vigo | Permiso B | Autoescuelas Faro",
    description: "Carnet de coche en Vigo con Autoescuelas Faro: teórica presencial y online, prácticas personalizadas y 5 centros entre Vigo y el Val Miñor.",
    schemaName: "Curso para obtener el permiso B (carnet de coche) en Vigo",
    eyebrow: "Permiso B · Más de 45 años en Vigo",
    h1: "Carnet de coche en Vigo – Permiso B",
    intro: [
      "El **permiso B** es el carnet más solicitado y tu llave para moverte con libertad. En Autoescuelas Faro lo preparas con **teórica presencial u online**, clases prácticas personalizadas y profesores que conocen al detalle los recorridos de examen de Vigo.",
      "Con **5 centros** en Vigo y su área (Plaza América, Coruxo, Panxón, Nigrán y A Cañiza), siempre tienes una autoescuela Faro cerca de casa.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de coche (permiso B) en Vigo",
    images: [
      { src: "/assets/coche-practicas-carnet-b-autoescuelas-faro-vigo.webp", alt: "Coche real de prácticas de Autoescuelas Faro para el carnet de coche en Vigo (permiso B)", caption: "Uno de nuestros coches de prácticas, con doble mando", fit: "contain" },
    ],
    stats: [
      { icon: "users", k: "18 años", v: "edad mínima (teórica desde los 17)" },
      { icon: "file", k: "30", v: "preguntas en el teórico (máx. 3 fallos)" },
      { icon: "car", k: "3.500 kg", v: "turismos de hasta 9 plazas" },
      { icon: "map", k: "5 centros", v: "en Vigo y su área metropolitana" },
    ],
    sections: [
      {
        h2: "¿Qué puedes conducir con el permiso B?",
        bullets: [
          "**Turismos y furgonetas** de hasta 3.500 kg de MMA y hasta 9 plazas (conductor incluido).",
          "Conjuntos con **remolque ligero** de hasta 750 kg.",
          "**Ciclomotores** y cuadriciclos ligeros.",
          "A los **3 años de carnet**, motos de hasta 125 cc (equivalencia A1, solo en España).",
        ],
      },
      {
        h2: "Cómo funciona el proceso en Faro",
        bullets: [
          "**Teórica a tu ritmo**: clases presenciales en cualquiera de nuestros centros o plataforma online con tests ilimitados tipo DGT.",
          "**Examen teórico**: 30 preguntas, apto con un máximo de 3 errores. Te presentamos cuando tus simulacros digan que estás listo.",
          "**Clases prácticas**: coches con doble mando, profesores pacientes y recorridos reales por las zonas de examen de Vigo.",
          "**Examen práctico**: unos 25 minutos de circulación por Vigo con examinador de la Jefatura de Tráfico.",
        ],
      },
      {
        h2: "Requisitos para sacarte el carnet de coche",
        bullets: [
          "Tener **18 años** (puedes examinarte de la teórica desde los 17 años y 9 meses).",
          "**DNI o NIE** en vigor y una fotografía tamaño carnet.",
          "**Psicotécnico** (certificado de aptitud psicofísica): te indicamos el centro de reconocimiento más cercano.",
          "Residencia habitual en España.",
        ],
      },
      {
        h2: "¿Por qué sacarte el B con Autoescuelas Faro?",
        bullets: [
          "**Más de 45 años** de experiencia formando conductores en Vigo.",
          "Profesores que conocen **todos los recorridos de examen** de la ciudad.",
          "Horarios de teórica flexibles: mañana, tarde y **formato intensivo**.",
          "Gestionamos **todo el papeleo** con la Jefatura de Tráfico por ti.",
        ],
      },
    ],
    centersNote: "Las clases prácticas se realizan en Vigo, por las zonas reales de examen.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de coche en Vigo?", a: "Depende de la modalidad de teórica y del número de clases prácticas que necesites. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 o llamando al 986 29 24 55 y te preparamos una propuesta a tu medida el mismo día." },
      { q: "¿Cuánto se tarda en sacar el carnet de coche?", a: "Con dedicación, la teórica puede estar lista en 3-4 semanas (menos en formato intensivo). El total depende de tu disponibilidad y de las fechas de examen de la Jefatura de Vigo: la media está entre 2 y 4 meses." },
      { q: "¿Puedo empezar antes de cumplir los 18?", a: "Sí. Puedes matricularte y preparar la teórica antes, y examinarte del teórico a partir de los 17 años y 9 meses. El examen práctico y el carnet requieren haber cumplido los 18." },
      { q: "¿La teórica es presencial u online?", a: "Las dos. Puedes venir a clases presenciales en cualquiera de nuestros 5 centros (Plaza América, Coruxo, Panxón, Nigrán y A Cañiza) o estudiar con nuestra plataforma online con tests ilimitados tipo examen DGT. Muchos alumnos combinan ambas." },
      { q: "¿Cómo es el examen teórico del permiso B?", a: "Es un test de 30 preguntas en el que puedes cometer un máximo de 3 errores. Se realiza en las instalaciones de la DGT y nosotros te presentamos cuando tus simulacros indican que estás preparado." },
      { q: "¿Cómo es el examen práctico en Vigo?", a: "Dura unos 25 minutos de circulación real por Vigo, con un examinador de Tráfico y tu profesor en el coche. Practicamos por las mismas zonas donde se examina, para que el día del examen no haya sorpresas." },
      { q: "¿Cuántas clases prácticas voy a necesitar?", a: "Es muy personal: hay alumnos que necesitan 15 clases y otros 30 o más. Tu profesor te dará una estimación honesta tras las primeras clases y solo te recomendará presentarte cuando estés realmente preparado." },
      { q: "¿Qué pasa si suspendo?", a: "No pasa nada, le ocurre a muchos alumnos. Cada tasa de Tráfico incluye dos convocatorias. Analizamos contigo los fallos y reforzamos justo lo que necesitas antes de la siguiente convocatoria." },
      { q: "¿Qué documentación necesito para matricularme?", a: "DNI o NIE en vigor, una fotografía tamaño carnet y el certificado psicotécnico (te indicamos dónde hacerlo cerca de tu centro). Del resto del papeleo con Tráfico nos encargamos nosotros." },
      { q: "¿Con el carnet B puedo conducir una moto de 125?", a: "Sí, pero solo cuando tengas 3 años de antigüedad con el permiso B, y únicamente dentro de España. Si quieres conducir moto desde ya, echa un vistazo a nuestro carnet de moto en Vigo (A1, A2 y A)." },
    ],
    related: [
      { label: "Carnet de moto en Vigo", to: "/carnet-moto-vigo" },
      { label: "Carnet de remolque (B96 y B+E)", to: "/carnet-remolque-vigo" },
      { label: "Próximas convocatorias", to: "/proximos-cursos" },
    ],
    ctaTitle: "Empieza hoy con tu carnet de coche",
    ctaText: "Teórica presencial u online, prácticas personalizadas y 5 centros en Vigo y su área. Pide tu presupuesto sin compromiso.",
  },

  "carnet-moto-vigo": {
    title: "Carnet de Moto en Vigo | A1, A2 y A | Autoescuelas Faro",
    description: "Sácate el carnet de moto en Vigo: AM desde 15 años, A1 (125 cc), A2 y A. Motos propias, prácticas en circuito y circulación. 5 centros en Vigo y área.",
    schemaName: "Cursos para obtener los permisos de moto AM, A1, A2 y A en Vigo",
    eyebrow: "Permisos AM · A1 · A2 · A",
    h1: "Carnet de moto en Vigo – AM, A1, A2 y A",
    intro: [
      "¿Quieres moverte en moto por Vigo? Te preparamos para **todos los permisos de moto**: desde el ciclomotor a los 15 años hasta la moto sin límite de potencia. Con **motos propias**, equipación y prácticas reales de circuito y circulación.",
      "Elige tu permiso y nosotros nos encargamos del resto: teórica, prácticas y todo el papeleo con la DGT.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de moto en Vigo",
    images: [
      { src: "/assets/ciclomotor-yamaha-jog-permiso-am-vigo.webp", alt: "Yamaha JOG 50 cc de Autoescuelas Faro para el permiso AM en Vigo", caption: "Yamaha JOG 50 c.c. · Permiso AM" },
      { src: "/assets/moto-yamaha-cygnus-125-carnet-a1-vigo.webp", alt: "Yamaha Cygnus-X 125 cc de Autoescuelas Faro para el carnet A1 en Vigo", caption: "Yamaha Cygnus-X 125 c.c. · Permiso A1" },
      { src: "/assets/moto-kawasaki-z400-carnet-a2-vigo.webp", alt: "Kawasaki Z400 de Autoescuelas Faro para el carnet A2 en Vigo", caption: "Kawasaki Z400 · Permiso A2" },
      { src: "/assets/moto-ducati-monster-permiso-a-vigo.webp", alt: "Ducati Monster 695 de Autoescuelas Faro para el permiso A en Vigo", caption: "Ducati Monster 695 c.c. · Permiso A" },
    ],
    stats: [
      { icon: "bike", k: "4", v: "permisos: AM, A1, A2 y A" },
      { icon: "users", k: "15 años", v: "edad mínima para el AM" },
      { icon: "gauge", k: "125 cc", v: "con el A1 desde los 16 años" },
      { icon: "badge", k: "Motos", v: "propias con equipación incluida" },
    ],
    sections: [
      {
        h2: "¿Qué permiso de moto necesitas?",
        cards: [
          {
            title: "AM · Ciclomotor (15 años)",
            text: "Ciclomotores de hasta 50 cc y 45 km/h. El primer paso para moverte por Vigo con tu propio vehículo.",
            bullets: ["Teórico específico de 20 preguntas", "Prueba de destreza en circuito", "**Sin examen** de circulación"],
          },
          {
            title: "A1 · Moto 125 (16 años)",
            text: "Motocicletas de hasta 125 cc y 11 kW. Ideal para ciudad y para empezar en el mundo de la moto.",
            bullets: ["Teórico común + teórico específico", "Destreza en circuito cerrado", "Examen de circulación en Vigo"],
            link: { to: "/carnet-a1-vigo", label: "Todo sobre el carnet A1 en Vigo" },
          },
          {
            title: "A2 · Hasta 35 kW (18 años)",
            text: "Motos de hasta 35 kW (unos 47 CV). El permiso de moto más demandado y paso obligatorio antes del A.",
            bullets: ["Teórico común + específico (si no tienes B)", "Destreza en circuito + circulación", "Con carnet B solo haces el específico y las prácticas"],
            link: { to: "/carnet-a2-vigo", label: "Todo sobre el carnet A2 en Vigo" },
          },
          {
            title: "A · Sin límite (20 años)",
            text: "Cualquier motocicleta, sin restricción de potencia. Se accede desde el A2.",
            bullets: ["**2 años** de antigüedad con el A2", "Curso de formación de **9 horas**", "**Sin examen**: solo el curso"],
          },
        ],
      },
      {
        h2: "Cómo son las pruebas del carnet de moto",
        bullets: [
          "**Teórico**: común (30 preguntas) si no tienes otro permiso, más el específico de moto (20 preguntas, máximo 2 fallos).",
          "**Destreza en circuito cerrado**: zigzag, equilibrio a baja velocidad, esquiva y frenada. Entrenamos cada maniobra hasta que te salga sola.",
          "**Circulación**: recorrido real por Vigo siguiendo las indicaciones del examinador desde un vehículo de apoyo.",
          "Consulta las faltas oficiales del examen en nuestro selector de criterios DGT.",
        ],
      },
      {
        h2: "¿Por qué sacarte la moto con Faro?",
        bullets: [
          "**Motos propias** de todas las cilindradas y equipación homologada (casco, guantes e intercomunicador).",
          "Prácticas de **circuito** en pista para dominar las maniobras del examen.",
          "Si ya tienes el carnet B, el proceso es más corto: **sin teórico común**.",
          "Más de 45 años preparando motoristas en Vigo.",
        ],
      },
    ],
    centersNote: "Las prácticas de circuito y circulación se realizan en Vigo con nuestras motos y equipación.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de moto en Vigo?", a: "Depende del permiso (AM, A1, A2 o A) y de si ya tienes otro carnet, porque cambia el número de pruebas. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 y te lo preparamos a medida." },
      { q: "¿A qué edad puedo sacarme cada permiso de moto?", a: "AM a los 15 años, A1 a los 16, A2 a los 18 y A a los 20 (siempre que lleves 2 años con el A2). Puedes empezar la formación un poco antes de cumplir la edad." },
      { q: "Tengo el carnet B, ¿qué necesito para llevar una 125?", a: "Si tienes 3 años de antigüedad con el B puedes conducir motos de hasta 125 cc en España sin examen. Si no quieres esperar o quieres el permiso A1 completo (válido también fuera de España), te preparamos el examen específico de moto." },
      { q: "¿Necesito hacer el teórico si ya tengo el carnet de coche?", a: "Solo el teórico específico de moto (20 preguntas, máximo 2 fallos). El teórico común queda convalidado con tu permiso B." },
      { q: "¿La autoescuela pone la moto y el equipo?", a: "Sí. Contamos con motos propias de todas las cilindradas y te dejamos casco, guantes e intercomunicador para las clases y para el examen." },
      { q: "¿Cómo es la prueba de circuito (destreza)?", a: "Se realiza en pista cerrada e incluye maniobras como zigzag entre conos, equilibrio a baja velocidad, esquiva y frenada de emergencia. Las entrenamos una a una hasta que las domines. Puedes ver las faltas oficiales en nuestra página de criterios DGT." },
      { q: "¿Cómo se pasa del A2 al A?", a: "Sin examen: cuando llevas 2 años con el A2, haces un curso de formación de 9 horas (teoría y prácticas) y obtienes el permiso A para conducir cualquier moto." },
      { q: "¿Cuánto se tarda en sacar el carnet de moto?", a: "Si ya tienes el B, en pocas semanas puedes tenerlo: solo necesitas el teórico específico y las prácticas. Si empiezas de cero, calcula entre 1 y 3 meses según tu disponibilidad y las fechas de examen en Vigo." },
      { q: "¿Dónde se hacen los exámenes de moto en Vigo?", a: "La prueba de destreza se realiza en las pistas de examen y la de circulación por las calles de Vigo, siguiendo a un vehículo de la autoescuela desde el que el examinador te da las indicaciones." },
      { q: "¿Puedo matricularme en Nigrán, Panxón o A Cañiza?", a: "Sí. Puedes matricularte y preparar la teórica en cualquiera de nuestros 5 centros. Las prácticas de moto se organizan en Vigo con nuestras motos y equipación." },
    ],
    related: [
      { label: "Carnet A1 (125 cc)", to: "/carnet-a1-vigo" },
      { label: "Carnet A2 (35 kW)", to: "/carnet-a2-vigo" },
      { label: "Carnet de coche en Vigo", to: "/carnet-coche-vigo" },
      { label: "Criterios de examen DGT", to: "/criterios-dgt" },
      { label: "Pistas de examen DGT", to: "/pistas-examen-dgt-vigo" },
    ],
    ctaTitle: "Tu carnet de moto empieza aquí",
    ctaText: "AM, A1, A2 y A con motos propias y prácticas reales en Vigo. Pide tu presupuesto sin compromiso.",
  },

  "carnet-camion-vigo": {
    title: "Carnet de Camión en Vigo | Permiso C + CAP | Autoescuelas Faro",
    description: "Sácate el carnet de camión en Vigo con Autoescuelas Faro: permisos C y C1, camiones propios, prácticas en pista y circulación. Prepara también el CAP.",
    schemaName: "Curso para obtener el permiso C (carnet de camión) en Vigo",
    eyebrow: "Permisos C y C1 · Formación profesional",
    h1: "Carnet de camión en Vigo – Permiso C",
    intro: [
      "El **permiso C** te abre las puertas del transporte profesional: uno de los sectores con **más demanda de empleo** en Galicia. En Faro lo preparas con **camiones propios**, profesores especializados en permisos profesionales y prácticas en pista y circulación.",
      "Y si vas a trabajar como conductor, aquí mismo preparas el **CAP**: somos centro de formación autorizado.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de camión (permiso C) en Vigo",
    images: [
      { src: "/assets/camion-carnet-c-vigo.webp", alt: "Camión de Autoescuelas Faro para el carnet de camión (permiso C) en Vigo", caption: "Nuestro camión de prácticas y examen del permiso C" },
    ],
    stats: [
      { icon: "truck", k: "+3.500 kg", v: "camiones sin límite de MMA" },
      { icon: "users", k: "21 años", v: "edad mínima (18 con CAP)" },
      { icon: "badge", k: "Camiones", v: "propios para prácticas y examen" },
      { icon: "cap", k: "CAP", v: "prepáralo en el mismo centro" },
    ],
    sections: [
      {
        h2: "¿Qué puedes conducir con el permiso C?",
        bullets: [
          "**Camiones rígidos** de más de 3.500 kg de MMA, sin límite de peso.",
          "Conjuntos con **remolque ligero** de hasta 750 kg.",
          "Con el **C1** (desde los 18 años): camiones de entre 3.500 y 7.500 kg.",
          "Para arrastrar remolques pesados necesitarás después el **C+E (tráiler)**.",
        ],
      },
      {
        h2: "Requisitos para el carnet de camión",
        bullets: [
          "Tener el **permiso B** en vigor.",
          "**21 años** para el C (o 18 si obtienes el CAP de mercancías); **18 años** para el C1.",
          "**Psicotécnico de grupo 2** (más completo que el del coche).",
          "DNI o NIE en vigor y una fotografía tamaño carnet.",
        ],
      },
      {
        h2: "Cómo son las pruebas del permiso C",
        bullets: [
          "**Teórico específico** de camión: 20 preguntas (máximo 2 fallos) sobre tacógrafo, tiempos de conducción y descanso, masas y dimensiones.",
          "**Prueba de destreza en pista**: maniobras con el camión (marcha atrás en L, acoplamiento, estacionamiento).",
          "**Circulación**: recorrido real por Vigo con el examinador a bordo.",
          "Consulta las faltas oficiales del examen de camión en nuestro selector de criterios DGT.",
        ],
      },
      {
        h2: "Camión + CAP: el pack completo para trabajar",
        paras: [
          "Para conducir un camión **profesionalmente** necesitas, además del permiso C, el **Certificado de Aptitud Profesional (CAP)**. En Faro puedes preparar los dos a la vez y ahorrar tiempo: consulta nuestro curso CAP en Vigo. Obteniendo el CAP inicial, además, puedes sacarte el permiso C desde los **18 años**.",
        ],
      },
    ],
    centersNote: "Las prácticas con camión se realizan en Vigo, en pista y por las zonas reales de examen.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de camión en Vigo?", a: "Depende de las clases prácticas que necesites y de si lo combinas con el CAP. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 o llamando al 986 29 24 55: te preparamos una propuesta a medida, también para el pack C + CAP." },
      { q: "¿Qué necesito para sacarme el permiso C?", a: "Tener el permiso B en vigor, 21 años (o 18 si obtienes el CAP de mercancías), superar el psicotécnico de grupo 2 y aprobar el teórico específico, la prueba de pista y la de circulación." },
      { q: "¿Puedo sacarme el carnet de camión con 18 años?", a: "Sí, de dos formas: con el permiso C1 (camiones hasta 7.500 kg) directamente a los 18, o con el permiso C completo si obtienes el CAP inicial de mercancías. Te asesoramos sobre la mejor vía según tu caso." },
      { q: "¿Cuánto se tarda en sacar el permiso C?", a: "Si te dedicas en serio, entre 1 y 3 meses. El teórico específico es más corto que el del B (20 preguntas) y las prácticas van rápido porque ya sabes conducir." },
      { q: "¿Tengo que volver a hacer el teórico común?", a: "No. Al tener el permiso B, solo haces el teórico específico de camión: 20 preguntas con un máximo de 2 fallos, centrado en tacógrafo, tiempos de conducción y masas." },
      { q: "¿Con qué camión haré las prácticas y el examen?", a: "Con los camiones propios de Autoescuelas Faro, los mismos con los que te examinarás. Los conocerás al detalle antes del examen." },
      { q: "¿Necesito el CAP para conducir un camión?", a: "Solo si conduces profesionalmente (por cuenta ajena o propia con ánimo de lucro). Para uso particular basta el permiso C. Si vas a trabajar, prepara el CAP inicial con nosotros: somos centro autorizado." },
      { q: "¿Qué es el psicotécnico de grupo 2?", a: "Es el reconocimiento médico obligatorio para permisos profesionales (C, C+E, D). Es algo más completo que el del coche y se hace en cualquier centro de reconocimiento de conductores; te indicamos el más cercano a tu centro Faro." },
      { q: "¿Hay salidas de trabajo con el carnet de camión?", a: "Sí. El transporte de mercancías es uno de los sectores con más escasez de conductores en España y Galicia. Con el C + CAP (y aún más con el C+E) tendrás ofertas tanto en reparto regional como en ruta nacional e internacional." },
      { q: "¿Puedo hacer el C y el C+E seguidos?", a: "Sí, es lo que hacen muchos alumnos: al terminar el C encadenan el C+E (tráiler) aprovechando la práctica ganada. Pídenos presupuesto del pack completo." },
    ],
    related: [
      { label: "Carnet de tráiler (C+E)", to: "/carnet-trailer-ce-vigo" },
      { label: "Curso CAP en Vigo", to: "/curso-cap-vigo" },
      { label: "Carnet de autobús (D)", to: "/carnet-autobus-vigo" },
    ],
    ctaTitle: "Hazte conductor profesional",
    ctaText: "Permiso C con camiones propios y opción de pack con CAP. El sector del transporte te está esperando.",
  },

  "carnet-trailer-ce-vigo": {
    title: "Carnet C+E en Vigo | Carnet de Tráiler | Autoescuelas Faro",
    description: "Sácate el carnet de tráiler (C+E) en Vigo: camión articulado con semirremolque, prácticas en pista y circulación con vehículo propio.",
    schemaName: "Curso para obtener el permiso C+E (carnet de tráiler) en Vigo",
    eyebrow: "Permiso C+E · Camión articulado",
    h1: "Carnet C+E (tráiler) en Vigo",
    intro: [
      "El **permiso C+E** es el título más valorado del transporte por carretera: te permite conducir el **camión articulado (tráiler)** y acceder a las rutas nacionales e internacionales **mejor pagadas** del sector.",
      "En Faro lo preparas con nuestro propio conjunto de camión y semirremolque, entrenando el enganche, las maniobras de pista y la circulación real por Vigo.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de tráiler (C+E) en Vigo",
    images: [
      { src: "/assets/camion-trailer-carnet-ce-vigo.webp", alt: "Camión articulado con semirremolque de Autoescuelas Faro para el carnet de tráiler C+E en Vigo", caption: "Nuestro conjunto articulado para las prácticas del C+E" },
    ],
    stats: [
      { icon: "truck", k: "40 t", v: "conjuntos articulados de gran tonelaje" },
      { icon: "users", k: "21 años", v: "edad mínima (18 con CAP)" },
      { icon: "file", k: "Sin común", v: "solo teórico específico" },
      { icon: "badge", k: "Tráiler", v: "propio para prácticas y examen" },
    ],
    sections: [
      {
        h2: "¿Qué puedes conducir con el C+E?",
        bullets: [
          "**Camión articulado**: cabeza tractora con semirremolque (el tráiler clásico de hasta 40 toneladas).",
          "**Tren de carretera**: camión rígido con remolque de más de 750 kg.",
          "Además, el C+E te convalida el **B+E** (turismo con remolque pesado).",
        ],
      },
      {
        h2: "Requisitos para el carnet de tráiler",
        bullets: [
          "Tener el **permiso C en vigor** (si aún no lo tienes, mira nuestro carnet de camión en Vigo; muchos alumnos hacen C y C+E seguidos).",
          "**21 años** (o 18 con el CAP inicial de mercancías).",
          "**Psicotécnico de grupo 2** en vigor.",
          "DNI o NIE y una fotografía tamaño carnet.",
        ],
      },
      {
        h2: "Cómo son las pruebas del C+E",
        bullets: [
          "**Teórico específico** de conjuntos: 20 preguntas (máximo 2 fallos) sobre enganche, masas, dimensiones y estabilidad del conjunto.",
          "**Destreza en pista**: la prueba clave del tráiler — marcha atrás con articulación, acoplamiento y desacoplamiento del semirremolque.",
          "**Circulación**: recorrido por Vigo y sus accesos con el conjunto completo.",
          "Consulta las faltas oficiales del examen C+E en nuestro selector de criterios DGT.",
        ],
      },
      {
        h2: "El permiso con más salidas del transporte",
        paras: [
          "Las empresas de transporte buscan conductores de tráiler constantemente: ruta nacional, internacional, portacontenedores del puerto de Vigo, cisternas o frigoríficos. Con el **C+E y el CAP** en la mano, el empleo está prácticamente garantizado en el sector.",
        ],
      },
    ],
    centersNote: "Las prácticas con el tráiler se realizan en Vigo, en pista y por los accesos y viales reales de examen.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de tráiler en Vigo?", a: "Depende del número de prácticas que necesites y de si lo combinas con el C o el CAP. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 y te preparamos una propuesta a tu medida." },
      { q: "¿Qué necesito para sacarme el C+E?", a: "Tener el permiso C en vigor, 21 años (o 18 con CAP de mercancías), psicotécnico de grupo 2 y superar tres pruebas: teórico específico, destreza en pista y circulación." },
      { q: "¿Puedo hacer el C y el C+E a la vez?", a: "Debes obtener primero el C, pero puedes encadenarlos sin pausa: es lo más habitual y lo más eficiente, porque llegas al C+E con la práctica fresca. Pídenos presupuesto del pack C + C+E." },
      { q: "¿Cuánto se tarda en sacar el carnet de tráiler?", a: "Si ya tienes el C, normalmente entre 1 y 2 meses: el teórico específico es corto y las prácticas se centran en el manejo del conjunto articulado." },
      { q: "¿Cómo es la prueba de pista del tráiler?", a: "Es la parte decisiva: marcha atrás con articulación entre conos, acoplamiento y desacoplamiento del semirremolque. La entrenamos hasta que controles el ángulo del conjunto con soltura." },
      { q: "¿Hay que hacer teórico común otra vez?", a: "No. Solo el teórico específico de conjuntos: 20 preguntas con máximo 2 fallos, sobre enganche, masas y estabilidad." },
      { q: "¿El C+E me convalida algún otro permiso?", a: "Sí: obtienes automáticamente el B+E (turismo con remolque pesado). Y si tuvieras el D, el C+E te daría también el D+E." },
      { q: "¿Necesito el CAP para trabajar con el tráiler?", a: "Sí, para el transporte profesional de mercancías necesitas el CAP además del C+E. Puedes prepararlo en nuestro centro: somos centro de formación CAP autorizado en Vigo." },
      { q: "¿Qué salario tiene un conductor de tráiler?", a: "Varía según ruta y empresa, pero los conductores C+E están entre los mejor pagados del transporte, especialmente en ruta internacional. La escasez de conductores hace que las condiciones mejoren año a año." },
      { q: "¿Con qué vehículo me examino?", a: "Con el conjunto de camión y semirremolque de Autoescuelas Faro, el mismo con el que habrás hecho todas las prácticas." },
    ],
    related: [
      { label: "Carnet de camión (C)", to: "/carnet-camion-vigo" },
      { label: "Curso CAP en Vigo", to: "/curso-cap-vigo" },
      { label: "Criterios de examen DGT", to: "/criterios-dgt" },
    ],
    ctaTitle: "Súbete al tráiler",
    ctaText: "El permiso mejor pagado del transporte, con vehículo articulado propio para prácticas y examen.",
  },

  "carnet-autobus-vigo": {
    title: "Carnet de Autobús en Vigo | Permiso D + CAP | Autoescuelas Faro",
    description: "Sácate el carnet de autobús (permiso D) en Vigo con Autoescuelas Faro: autobús propio, prácticas en pista y circulación, y preparación del CAP de viajeros.",
    schemaName: "Curso para obtener el permiso D (carnet de autobús) en Vigo",
    eyebrow: "Permiso D · Transporte de viajeros",
    h1: "Carnet de autobús en Vigo – Permiso D",
    intro: [
      "El **permiso D** te habilita para conducir **autobuses sin límite de plazas**: urbanos, interurbanos, escolares y discrecionales. Un sector con **demanda constante de conductores** en Vigo y toda Galicia.",
      "En Faro lo preparas con autobús propio, profesores especializados en permisos profesionales y la opción de completar el **CAP de viajeros** en el mismo centro.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de autobús (permiso D) en Vigo",
    images: [
      { src: "/assets/autobus-carnet-d-vigo.webp", alt: "Autobús de Autoescuelas Faro para el carnet de autobús (permiso D) en Vigo", caption: "Nuestro autobús de prácticas y examen del permiso D" },
    ],
    stats: [
      { icon: "bus", k: "Sin límite", v: "de plazas: urbano, escolar, discrecional" },
      { icon: "users", k: "24 años", v: "edad mínima (21 con CAP)" },
      { icon: "badge", k: "Autobús", v: "propio para prácticas y examen" },
      { icon: "cap", k: "CAP", v: "de viajeros en el mismo centro" },
    ],
    sections: [
      {
        h2: "¿Qué puedes conducir con el permiso D?",
        bullets: [
          "**Autobuses y autocares** de más de 9 plazas, sin límite de pasajeros.",
          "Conjuntos con **remolque ligero** de hasta 750 kg.",
          "Transporte **urbano, interurbano, escolar y discrecional**.",
        ],
      },
      {
        h2: "Requisitos para el carnet de autobús",
        bullets: [
          "Tener el **permiso B** en vigor.",
          "**24 años** (o 21 si obtienes el CAP de viajeros).",
          "**Psicotécnico de grupo 2** en vigor.",
          "DNI o NIE y una fotografía tamaño carnet.",
        ],
      },
      {
        h2: "Cómo son las pruebas del permiso D",
        bullets: [
          "**Teórico específico** de autobús: 20 preguntas (máximo 2 fallos) sobre transporte de viajeros, tiempos de conducción y seguridad de los pasajeros.",
          "**Destreza en pista**: maniobras con el autobús — precisión en un vehículo de gran longitud.",
          "**Circulación**: recorrido real por Vigo con el examinador a bordo.",
          "Consulta las faltas oficiales del examen de autobús en nuestro selector de criterios DGT.",
        ],
      },
      {
        h2: "Un sector que necesita conductores",
        paras: [
          "Empresas de transporte urbano, líneas regulares, transporte escolar y turístico buscan conductores con permiso D de forma continua. Con el **D + CAP de viajeros** tendrás un perfil profesional muy demandado, con horarios más estables que el transporte de mercancías.",
        ],
      },
    ],
    centersNote: "Las prácticas con autobús se realizan en Vigo, en pista y por los recorridos reales de examen.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de autobús en Vigo?", a: "Depende de las prácticas que necesites y de si lo combinas con el CAP de viajeros. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 o llamando al 986 29 24 55." },
      { q: "¿Qué necesito para sacarme el permiso D?", a: "Tener el permiso B en vigor, 24 años (o 21 si obtienes el CAP de viajeros), psicotécnico de grupo 2 y superar el teórico específico, la prueba de pista y la de circulación." },
      { q: "¿Puedo sacarme el D antes de los 24?", a: "Sí: con 21 años si obtienes el CAP inicial de viajeros. En algunos supuestos de líneas regulares cortas la normativa contempla edades inferiores. Te asesoramos según tu caso concreto." },
      { q: "¿Cuánto se tarda en sacar el carnet de autobús?", a: "Entre 1 y 3 meses según tu disponibilidad. El teórico específico es corto y las prácticas avanzan rápido al tener ya experiencia al volante." },
      { q: "¿Necesito el permiso C antes del D?", a: "No. Solo necesitas el permiso B en vigor. C y D son ramas independientes: mercancías y viajeros." },
      { q: "¿Es difícil conducir un autobús?", a: "Sorprende lo manejable que resulta: dirección asistida, cambio automático en muchos modelos y gran visibilidad. El reto está en la anticipación y la suavidad, y eso es justo lo que entrenamos." },
      { q: "¿Necesito el CAP para trabajar de conductor de autobús?", a: "Sí, para el transporte profesional de viajeros necesitas el CAP además del permiso D. Somos centro autorizado: puedes preparar el D y el CAP de viajeros a la vez." },
      { q: "¿Hay trabajo con el carnet de autobús en Vigo?", a: "Sí. Vitrasa, líneas interurbanas, transporte escolar y empresas discrecionales de la zona necesitan conductores de forma constante. La jubilación de las plantillas actuales garantiza demanda en los próximos años." },
      { q: "¿Con qué autobús haré las prácticas y el examen?", a: "Con el autobús propio de Autoescuelas Faro, el mismo vehículo para las prácticas y para el día del examen." },
      { q: "¿Qué es el psicotécnico de grupo 2?", a: "El reconocimiento médico exigido para permisos profesionales (C, D). Se hace en cualquier centro de reconocimiento de conductores; te indicamos el más próximo a tu centro Faro." },
    ],
    related: [
      { label: "Curso CAP en Vigo", to: "/curso-cap-vigo" },
      { label: "Carnet de camión (C)", to: "/carnet-camion-vigo" },
      { label: "Próximas convocatorias", to: "/proximos-cursos" },
    ],
    ctaTitle: "Conduce el futuro del transporte de viajeros",
    ctaText: "Permiso D con autobús propio y CAP de viajeros en el mismo centro. Pide tu presupuesto.",
  },

  "carnet-remolque-vigo": {
    title: "Carnet de Remolque en Vigo | B96 y B+E | Autoescuelas Faro",
    description: "Sácate el carnet de remolque en Vigo: B96 (hasta 4.250 kg, sin teórico) y B+E (remolques pesados). Únicos con vehículo B96 equipado con cámaras 360º.",
    schemaName: "Cursos para obtener las autorizaciones B96 y B+E (remolques) en Vigo",
    eyebrow: "B96 y B+E · Remolques y caravanas",
    h1: "Carnet de remolque en Vigo – B96 y B+E",
    intro: [
      "¿Caravana, remolque para el barco, para caballos o de trabajo? Si con tu carnet B te quedas corto de peso, necesitas el **B96** o el **B+E**. El B96 no tiene examen teórico; el B+E solo un teórico específico de 20 preguntas.",
      "Somos los únicos de la zona con el vehículo del **B96 equipado con cámaras 360º** para que aprendas las maniobras con remolque viéndolo todo.",
    ],
    waMessage: "Hola, quiero un presupuesto para el carnet de remolque (B96 o B+E) en Vigo",
    images: [
      { src: "/assets/coche-remolque-carnet-b96-vigo.webp", alt: "Coche con remolque de Autoescuelas Faro para el B96 en Vigo", caption: "Conjunto coche + remolque · B96" },
      { src: "/assets/furgoneta-remolque-carnet-be-vigo.webp", alt: "Furgoneta con remolque de Autoescuelas Faro adaptada para el examen B+E en Vigo", caption: "Vehículo adaptado para examen B+E" },
    ],
    stats: [
      { icon: "caravan", k: "2", v: "opciones: B96 y B+E" },
      { icon: "file", k: "20 preguntas", v: "teórico solo en el B+E (2 fallos permitidos)" },
      { icon: "badge", k: "360º", v: "cámaras en el vehículo del B96" },
      { icon: "users", k: "18 años", v: "edad mínima (con permiso B)" },
    ],
    sections: [
      {
        h2: "¿B96 o B+E? Elige según tu remolque",
        cards: [
          {
            title: "B96 · Conjunto hasta 4.250 kg",
            text: "Autorización para conjuntos de coche + remolque de entre 3.500 y 4.250 kg de MMA total. Ideal para caravanas y remolques medianos.",
            bullets: ["**Sin examen teórico**: destreza en pista + circulación", "Maniobras: **aparcamiento en línea** y **desenganche y reenganche** (con nuestras cámaras 360º)", "Se anota en tu permiso B (código 96)"],
          },
          {
            title: "B+E · Remolques pesados",
            text: "Permiso para remolques de hasta 3.500 kg enganchados a tu turismo o furgoneta (conjunto de hasta 7.000 kg).",
            bullets: ["Examen **teórico específico de 20 preguntas** (2 fallos permitidos)", "Pruebas de **destreza en pista + circulación**", "Maniobras: **recta y curva marcha atrás, muelle y desenganche y reenganche**"],
          },
        ],
      },
      {
        h2: "¿Cuál necesitas? La regla rápida",
        bullets: [
          "Con el **B a secas**: remolque de hasta 750 kg, o mayor si el conjunto no pasa de 3.500 kg.",
          "**B96**: si el conjunto coche + remolque pesa entre 3.500 y 4.250 kg (la mayoría de caravanas familiares).",
          "**B+E**: si el remolque supera lo anterior, hasta 3.500 kg de remolque.",
          "¿Dudas con los pesos? Mándanos por WhatsApp la ficha técnica de tu coche y remolque y te decimos cuál necesitas.",
        ],
      },
      {
        h2: "Cómo son las pruebas",
        bullets: [
          "**Teórico** (solo B+E): examen específico de 20 preguntas con 2 fallos permitidos. El B96 no tiene examen teórico.",
          "**Destreza en pista** (B96 y B+E): en el B96, aparcamiento en línea y desenganche y reenganche — con las cámaras 360º de nuestro vehículo es mucho más sencillo (nuestra competencia no tiene vehículo con cámaras). En el B+E: recta y curva marcha atrás, muelle y desenganche y reenganche.",
          "**Circulación** (B96 y B+E): recorrido por Vigo con el conjunto.",
          "Consulta las faltas oficiales de B96 y B+E en nuestro selector de criterios DGT.",
        ],
      },
    ],
    centersNote: "Las prácticas con remolque se realizan en Vigo. El vehículo del B96 está equipado con cámaras 360º.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de remolque en Vigo?", a: "Depende de si necesitas B96 o B+E y de las prácticas que requieras (suelen ser pocas). Solicita presupuesto sin compromiso por WhatsApp al 658 790 266." },
      { q: "¿B96 y B+E tienen examen teórico?", a: "El B96 no tiene examen teórico: se examina de destreza en pista y de circulación. El B+E sí: un teórico específico de 20 preguntas en el que se permiten 2 fallos, además de la destreza en pista y la circulación." },
      { q: "¿Qué diferencia hay entre B96 y B+E?", a: "El B96 autoriza conjuntos de hasta 4.250 kg de MMA total, sin teórico (destreza + circulación). El B+E permite remolques de hasta 3.500 kg (conjuntos de hasta 7.000 kg) y exige un teórico de 20 preguntas, destreza y circulación. Si tu remolque es grande, necesitas el B+E." },
      { q: "¿Para llevar una caravana qué necesito?", a: "Depende del peso: la mayoría de caravanas familiares con un turismo entran en el B96. Si el conjunto supera los 4.250 kg, necesitas el B+E. Mándanos las fichas técnicas por WhatsApp y te lo confirmamos al momento." },
      { q: "¿Cuánto se tarda en sacar el B96 o el B+E?", a: "Es de lo más rápido que hay: el B96 no tiene teórico y el del B+E es breve (20 preguntas). En 2-4 semanas puedes tenerlo, según las prácticas que necesites y las fechas de examen disponibles en Vigo." },
      { q: "¿Cómo es la prueba de destreza con remolque?", a: "Depende del permiso. En el B96: aparcamiento en línea y desenganche y reenganche — con nuestro vehículo de cámaras 360º es mucho más sencillo (nuestra competencia no dispone de vehículo con cámaras). En el B+E: recta y curva marcha atrás, muelle y desenganche y reenganche." },
      { q: "¿Qué requisitos hay?", a: "Tener el permiso B en vigor y 18 años. Para el B+E, psicotécnico específico y un examen teórico de 20 preguntas. El B96 no tiene teórico." },
      { q: "¿El B96 es un permiso nuevo?", a: "No es un permiso aparte: es una autorización que se anota en tu permiso B con el código 96. No cambia tu carnet ni su renovación." },
      { q: "¿Puedo llevar un remolque para el barco o los caballos?", a: "Sí, es uno de los usos más habituales del B+E: remolques portaembarcaciones, vans para caballos y remolques de maquinaria. Según el peso del conjunto puede bastarte el B96." },
      { q: "¿Dónde hago las prácticas?", a: "En Vigo, en pista y en circulación real, con los vehículos y remolques de la autoescuela. El vehículo del B96 está equipado con cámaras 360º." },
    ],
    related: [
      { label: "Carnet de coche en Vigo", to: "/carnet-coche-vigo" },
      { label: "Carnet de tráiler (C+E)", to: "/carnet-trailer-ce-vigo" },
      { label: "Criterios de examen DGT", to: "/criterios-dgt" },
      { label: "Pistas de examen DGT", to: "/pistas-examen-dgt-vigo" },
    ],
    ctaTitle: "Engancha tu remolque sin miedo",
    ctaText: "B96 sin teórico y B+E con un teórico de solo 20 preguntas. Vehículo del B96 con cámaras 360º. En pocas semanas lo tienes.",
  },

  "curso-cap-vigo": {
    title: "Curso CAP en Vigo | Inicial y Renovación | Autoescuelas Faro",
    description: "Centro autorizado CAP en Vigo: CAP inicial de mercancías y viajeros, renovación de 35 h sin examen y CAP puente. Formación bonificada Fundae.",
    schemaName: "Curso CAP (Certificado de Aptitud Profesional) en Vigo",
    eyebrow: "CAP · Centro de formación autorizado",
    h1: "Curso CAP en Vigo para conductores profesionales",
    intro: [
      "El **CAP (Certificado de Aptitud Profesional)** es obligatorio para conducir profesionalmente camiones y autobuses. En nuestro centro autorizado de Vigo impartimos **todas las modalidades**: inicial (mercancías y viajeros), renovación cada 5 años y CAP puente.",
      "Con convocatorias regulares, horarios pensados para conductores en activo y **formación bonificada Fundae** para empresas.",
    ],
    waMessage: "Hola, quiero información y presupuesto del curso CAP en Vigo",
    images: [
      { src: "/assets/curso-cap-mercancias-viajeros-vigo.webp", alt: "Curso CAP de mercancías y viajeros de Autoescuelas Faro en Vigo", caption: "CAP de mercancías y viajeros en centro autorizado", fit: "contain" },
    ],
    stats: [
      { icon: "cap", k: "3", v: "modalidades: inicial, renovación y puente" },
      { icon: "clock", k: "35 h", v: "renovación cada 5 años, sin examen" },
      { icon: "truck", k: "2 ramas", v: "mercancías y viajeros (o ambas)" },
      { icon: "badge", k: "Fundae", v: "bonificable para empresas" },
    ],
    sections: [
      {
        h2: "Modalidades de CAP que impartimos",
        cards: [
          {
            title: "CAP Inicial",
            text: "La formación obligatoria para empezar a trabajar como conductor profesional de mercancías, viajeros o ambas.",
            bullets: ["**130 horas** teóricas", "**4 horas** en pista + 1 examen de pista", "**6 horas** en ciudad + 1 examen de ciudad", "Permite obtener el C a los 18 y el D a los 21"],
          },
          {
            title: "CAP Renovación (formación continua)",
            text: "Renueva tu certificado cada 5 años y mantén tu CAP en vigor sin interrumpir tu trabajo.",
            bullets: ["**35 horas** teóricas", "**Sin examen**", "Horarios compatibles con la jornada laboral", "Aparcamiento gratuito"],
          },
          {
            title: "CAP Puente o ampliación",
            text: "Para conductores que amplían de mercancías a viajeros (o viceversa) o con experiencia previa reconocida.",
            bullets: ["**32,5 horas** teóricas + **2,5 horas** prácticas", "Examen de 25 preguntas", "La vía rápida para trabajar en las dos ramas"],
          },
          {
            title: "Formación bonificada (empresas)",
            text: "Cursos CAP para empresas y trabajadores en activo con la bonificación Fundae gestionada íntegramente por nosotros.",
            bullets: ["Gestionamos la **bonificación Fundae**", "Sin coste para trabajador y empresa", "Grupos y fechas a medida"],
          },
        ],
      },
      {
        h2: "¿Quién está obligado a tener el CAP?",
        bullets: [
          "Todo conductor que realice **transporte profesional** con permisos C1, C, C+E (mercancías) o D1, D (viajeros).",
          "Tanto **asalariados como autónomos** con ánimo de lucro.",
          "La tarjeta CAP se renueva cada **5 años** con el curso de formación continua de 35 horas.",
          "Conducir profesionalmente sin CAP en vigor conlleva **sanciones** tanto al conductor como a la empresa.",
        ],
      },
      {
        h2: "CAP + permiso: el camino más rápido para trabajar",
        paras: [
          "Si aún no tienes el permiso de camión o autobús, en Faro puedes preparar el **pack completo**: permiso C + CAP de mercancías o permiso D + CAP de viajeros, en el mismo centro y coordinando las fechas. Además, el CAP inicial te permite obtener el **C a los 18 años** y el **D a los 21**.",
        ],
      },
    ],
    centersNote: "Los cursos CAP se imparten en nuestro centro de formación autorizado de Vigo, con aparcamiento gratuito.",
    faq: [
      { q: "¿Cuánto cuesta el curso CAP en Vigo?", a: "Depende de la modalidad (inicial, renovación o puente) y de si aplica la bonificación Fundae para empresas. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 o llamando al 986 29 24 55." },
      { q: "¿Qué es el CAP y quién lo necesita?", a: "El Certificado de Aptitud Profesional es obligatorio para conducir profesionalmente camiones (C1, C, C+E) y autobuses (D1, D), tanto por cuenta ajena como propia. Sin CAP en vigor no puedes trabajar de conductor." },
      { q: "¿Cuánto dura el CAP inicial?", a: "En nuestro centro: 130 horas teóricas, más 4 horas de prácticas en pista con su examen y 6 horas en ciudad con su examen. Puede hacerse de mercancías, de viajeros o de ambas ramas." },
      { q: "¿Cada cuánto se renueva el CAP?", a: "Cada 5 años, con el curso de formación continua de 35 horas. No tiene examen: se obtiene por asistencia. Te avisamos de las convocatorias para que nunca se te caduque." },
      { q: "¿El CAP de renovación tiene examen?", a: "No. Las 35 horas de formación continua se superan por asistencia y aprovechamiento, sin examen final." },
      { q: "¿Qué es el CAP puente?", a: "Es la formación reducida (32,5 horas teóricas + 2,5 prácticas, con examen de 25 preguntas) para conductores que ya tienen el CAP de una rama y quieren ampliar a la otra: de mercancías a viajeros o viceversa." },
      { q: "¿Puedo sacarme el permiso C a los 18 con el CAP?", a: "Sí. Obteniendo el CAP inicial de mercancías puedes conseguir el permiso C desde los 18 años (y el D desde los 21 con el CAP de viajeros). Es la vía rápida para empezar en el sector." },
      { q: "¿La empresa puede bonificar el curso CAP?", a: "Sí. Gestionamos íntegramente la bonificación Fundae para trabajadores en activo, de modo que la formación puede salir sin coste para el trabajador y la empresa." },
      { q: "¿Dónde se imparte el curso CAP en Vigo?", a: "En nuestro centro de formación autorizado en Vigo, con aparcamiento gratuito para los alumnos. Consulta las próximas convocatorias o pregúntanos por WhatsApp." },
      { q: "¿Qué pasa si se me caduca el CAP?", a: "No pierdes el certificado: basta con hacer el curso de formación continua de 35 horas para reactivarlo. Eso sí, no puedes conducir profesionalmente hasta renovarlo, así que conviene no apurar la fecha." },
    ],
    related: [
      { label: "Carnet de camión (C)", to: "/carnet-camion-vigo" },
      { label: "Carnet de tráiler (C+E)", to: "/carnet-trailer-ce-vigo" },
      { label: "Carnet de autobús (D)", to: "/carnet-autobus-vigo" },
    ],
    ctaTitle: "Tu CAP, sin complicaciones",
    ctaText: "Inicial, renovación y puente en centro autorizado de Vigo. Bonificación Fundae para empresas.",
  },

  "carnet-a1-vigo": {
    title: "Carnet de Moto A1 en Vigo | 125 cc desde los 16 años",
    description: "Sácate el carnet A1 en Vigo desde los 16 años: motos de hasta 125 cc y 11 kW. Moto automática o de marchas, prácticas de circuito y circulación.",
    schemaName: "Curso para obtener el permiso A1 (moto 125 cc) en Vigo",
    eyebrow: "Permiso A1 · Moto 125 desde los 16 años",
    h1: "Carnet A1 en Vigo: conduce motos de 125 cc desde los 16 años",
    intro: [
      "El **permiso A1** es la puerta de entrada al mundo de la moto: desde los **16 años** puedes conducir motocicletas de hasta **125 cc y 11 kW**, perfectas para moverte por Vigo sin atascos ni problemas de aparcamiento.",
      "En Faro lo preparas con **dos motos propias**: una scooter automática **Yamaha Cygnus-X 125** o una moto de marchas **Honda CB 125R**, con equipación incluida, y practicas en el mismo circuito en el que te examinas: **la DGT viene a examinar a nuestro circuito**. Para el examen de circulación practicaremos por las zonas más habituales de examen.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de moto A1 en Vigo",
    images: [
      { src: "/assets/moto-yamaha-cygnus-125-carnet-a1-vigo.webp", alt: "Yamaha Cygnus-X 125 cc de Autoescuelas Faro para el carnet A1 en Vigo", caption: "Yamaha Cygnus-X 125 · automática" },
      { src: "/assets/moto-honda-cb125r-carnet-a1-vigo.webp", alt: "Honda CB 125R de marchas de Autoescuelas Faro para el carnet A1 en Vigo", caption: "Honda CB 125R · de marchas" },
    ],
    stats: [
      { icon: "users", k: "16 años", v: "edad mínima" },
      { icon: "gauge", k: "125 cc", v: "hasta 11 kW de potencia" },
      { icon: "bike", k: "2 motos", v: "automática o de marchas" },
      { icon: "file", k: "20", v: "preguntas en el teórico específico" },
    ],
    sections: [
      {
        h2: "¿Automática o de marchas?",
        paras: [
          "Si te examinas con la **automática**, tu A1 queda limitado a motos automáticas. Si te examinas con la **de marchas**, podrás conducir motos de marchas y automáticas. Te ayudamos a elegir según el uso que le vayas a dar.",
        ],
      },
      {
        h2: "¿Qué puedes conducir con el A1?",
        bullets: [
          "**Motocicletas de hasta 125 cc** y 11 kW de potencia (relación potencia/peso máx. 0,1 kW/kg).",
          "**Triciclos de motor** de hasta 15 kW.",
          "Además, el A1 incluye el **AM** (ciclomotores).",
        ],
      },
      {
        h2: "Cómo son las pruebas del carnet A1",
        bullets: [
          "**Teórico común** (30 preguntas): solo si no tienes otro permiso.",
          "**Teórico específico** de moto: 20 preguntas, máximo 2 fallos.",
          "**Destreza en circuito cerrado**, en dos partes: la primera, de destreza a baja velocidad, y la segunda, cronometrada, que hay que completar en menos de 25 segundos.",
          "**Circulación** por Vigo siguiendo las indicaciones del examinador.",
        ],
        image: { src: "/assets/plano-circuito-cerrado-examen-moto.webp", alt: "Plano de la prueba de circuito cerrado del examen de moto: parte A de destreza a baja velocidad y parte B cronometrada en menos de 25 segundos", caption: "Plano de los ejercicios de la prueba de circuito cerrado", width: 1200, height: 740 },
      },
      {
        h2: "¿Y si ya tengo el carnet de coche?",
        paras: [
          "Con **3 años de antigüedad del permiso B** puedes conducir motos de 125 cc en España sin hacer nada más. Pero el **A1 completo** te permite conducir desde los 16, es válido **fuera de España** y es el primer paso natural hacia el A2 y el A. Si dudas entre las dos vías, te asesoramos sin compromiso.",
        ],
      },
      {
        h2: "Oposiciones de Correos",
        paras: [
          "**Especialistas en oposiciones y promociones internas de Correos.** Preparación rápida y adaptada a tus plazos para que tengas el carnet A1 a tiempo.",
        ],
      },
    ],
    centersNote: "Las prácticas de circuito y circulación del A1 se realizan en Vigo con nuestras motos de 125 (automática o de marchas) y equipación incluida.",
    faq: [
      { q: "¿Cuánto cuesta el carnet A1 en Vigo?", a: "Depende de si ya tienes otro permiso (te ahorras el teórico común) y de las prácticas que necesites. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266." },
      { q: "¿A qué edad puedo sacarme el A1?", a: "A los 16 años. Puedes matricularte y empezar la teórica un poco antes de cumplirlos." },
      { q: "¿Qué motos puedo llevar con el A1?", a: "Motocicletas de hasta 125 cc y 11 kW (unos 15 CV), como la mayoría de scooters y motos urbanas de 125. También triciclos de motor de hasta 15 kW y ciclomotores." },
      { q: "¿Qué exámenes tiene el A1?", a: "Teórico común (si no tienes otro permiso), teórico específico de moto (20 preguntas, máximo 2 fallos), prueba de destreza en circuito y prueba de circulación por Vigo." },
      { q: "¿La moto y el casco los pone la autoescuela?", a: "Sí. Practicas y te examinas con nuestras motos de 125 (automática o de marchas) y te dejamos casco, guantes e intercomunicador." },
      { q: "Tengo 18 años, ¿me conviene el A1 o el A2?", a: "Si tienes 18 o más, normalmente compensa ir directamente al A2: mismas pruebas pero con acceso a motos de hasta 35 kW. Consulta nuestra página del carnet A2 en Vigo o pregúntanos y te orientamos." },
      { q: "¿El A1 me sirve para el extranjero?", a: "Sí, el permiso A1 es válido en toda la UE, a diferencia de la equivalencia del carnet B con 3 años, que solo vale dentro de España." },
      { q: "¿Cuánto se tarda en sacar el A1?", a: "Entre 1 y 2 meses según tu disponibilidad y las fechas de examen en Vigo. Si ya tienes otro permiso, el proceso es más corto." },
    ],
    related: [
      { label: "Carnet A2 (35 kW)", to: "/carnet-a2-vigo" },
      { label: "Todos los carnets de moto", to: "/carnet-moto-vigo" },
      { label: "Criterios de examen DGT", to: "/criterios-dgt" },
      { label: "Pistas de examen DGT", to: "/pistas-examen-dgt-vigo" },
    ],
    ctaTitle: "Tu primera moto a los 16",
    ctaText: "Carnet A1 con nuestras motos de 125 (automática o de marchas) y equipación incluida. Pide tu presupuesto sin compromiso.",
  },

  "carnet-a2-vigo": {
    title: "Carnet A2 en Vigo (35 kW, desde 18) | Autoescuelas Faro",
    description: "Carnet A2 en Vigo: motos de hasta 35 kW desde los 18. Dos Kawasaki Z400 propias, circuito y circulación. Con A1 o B, sin teórico común.",
    schemaName: "Curso para obtener el permiso A2 (moto hasta 35 kW) en Vigo",
    eyebrow: "Permiso A2 · El carnet de moto más demandado",
    h1: "Carnet A2 en Vigo: motos de hasta 35 kW desde los 18 años",
    intro: [
      "El **permiso A2** es el carnet de moto más solicitado: desde los **18 años** te permite conducir motos de hasta **35 kW** (unos 47 CV), incluidas la mayoría de naked y trail medias del mercado.",
      "En Faro lo preparas con **nuestras motos propias, 2 Kawasaki Z400**, con equipación incluida, y practicas en el mismo circuito en el que te examinas: **la DGT viene a examinar a nuestro circuito**. Para el examen de circulación practicaremos por las zonas más habituales de examen.",
    ],
    waMessage: "Hola, quiero un presupuesto para sacarme el carnet de moto A2 en Vigo",
    images: [
      { src: "/assets/moto-kawasaki-z400-carnet-a2-vigo.webp", alt: "Kawasaki Z400 de Autoescuelas Faro para el carnet A2 en Vigo", caption: "Kawasaki Z400, la moto con la que practicarás el A2" },
    ],
    stats: [
      { icon: "users", k: "18 años", v: "edad mínima" },
      { icon: "gauge", k: "35 kW", v: "unos 47 CV de potencia máxima" },
      { icon: "bike", k: "Z400", v: "Kawasakis propias" },
      { icon: "badge", k: "Con A1 o B", v: "sin teórico común: solo específico" },
    ],
    sections: [
      {
        h2: "¿Qué puedes conducir con el A2?",
        bullets: [
          "**Motos de hasta 35 kW** (47,5 CV) y relación potencia/peso máx. 0,2 kW/kg.",
          "Motos más potentes **limitadas a 35 kW**, siempre que su potencia original no supere los 70 kW.",
          "El A2 incluye también el **A1 y el AM**.",
          "A los **2 años** podrás acceder al permiso A (sin límite) con un curso de 9 horas, sin examen.",
        ],
      },
      {
        h2: "Cómo son las pruebas del carnet A2",
        bullets: [
          "**Teórico común** (30 preguntas): solo si no tienes otro permiso. Con el carnet A1 o B queda convalidado.",
          "**Teórico específico** de moto: 20 preguntas, máximo 2 fallos.",
          "**Destreza en circuito cerrado**, en dos partes: la primera, de destreza a baja velocidad, y la segunda, cronometrada, que hay que completar en menos de 25 segundos.",
          "**Circulación** por Vigo siguiendo a un vehículo de apoyo desde el que el examinador da las indicaciones.",
        ],
        image: { src: "/assets/plano-circuito-cerrado-examen-moto.webp", alt: "Plano de la prueba de circuito cerrado del examen del carnet A2: parte A de destreza a baja velocidad y parte B cronometrada en menos de 25 segundos", caption: "Plano de los ejercicios de la prueba de circuito cerrado", width: 1200, height: 740 },
      },
      {
        h2: "Del A2 al A: el camino completo",
        paras: [
          "El A2 es el **paso obligatorio** hacia el permiso A (motos sin límite de potencia): tras 2 años con el A2, basta un curso de formación de 9 horas, sin examen. Muchos alumnos empiezan el A2 con nosotros y vuelven a los 2 años a completar el A con la Ducati Monster y la Yamaha XJ6.",
        ],
      },
    ],
    centersNote: "Las prácticas de circuito y circulación del A2 se realizan en Vigo con nuestras Kawasaki Z400 y equipación incluida.",
    faq: [
      { q: "¿Cuánto cuesta el carnet A2 en Vigo?", a: "Depende de si ya tienes el carnet B (te ahorras el teórico común) y del número de prácticas. Solicita presupuesto sin compromiso por WhatsApp al 658 790 266." },
      { q: "¿Qué motos puedo llevar con el A2?", a: "Motos de hasta 35 kW (unos 47 CV) y 0,2 kW/kg, como la Kawasaki Z400, MT-07 limitada, CB500... También motos más potentes limitadas a 35 kW si su potencia original no pasa de 70 kW." },
      { q: "Tengo el carnet de coche, ¿qué me ahorro?", a: "El teórico común. Solo tendrás que aprobar el teórico específico de moto (20 preguntas, máx. 2 fallos), la destreza en circuito y la circulación." },
      { q: "¿Con qué moto haré las prácticas y el examen?", a: "Con nuestras Kawasaki Z400, de las motos más manejables de su categoría. Te dejamos casco, guantes e intercomunicador." },
      { q: "¿Cómo es la prueba de circuito del A2?", a: "Tiene dos partes: la primera, de destreza a baja velocidad, y la segunda, cronometrada, que hay que completar en menos de 25 segundos. Practicas en el mismo circuito en el que te examinas. Puedes ver las faltas oficiales en nuestra página de criterios DGT." },
      { q: "¿Cuánto se tarda en sacar el A2?", a: "Si ya tienes el B, en pocas semanas: teórico específico + prácticas. Desde cero, entre 1 y 3 meses según tu ritmo y las fechas de examen en Vigo." },
      { q: "¿Cuándo puedo pasar al permiso A?", a: "A los 2 años de obtener el A2, con un curso de formación de 9 horas (sin examen) que también puedes hacer con nosotros." },
      { q: "¿Puedo empezar el A2 antes de cumplir 18?", a: "Puedes matricularte y preparar la teórica antes, pero los exámenes y el permiso requieren haber cumplido los 18 años." },
    ],
    related: [
      { label: "Carnet A1 (125 cc)", to: "/carnet-a1-vigo" },
      { label: "Todos los carnets de moto", to: "/carnet-moto-vigo" },
      { label: "Criterios de examen DGT", to: "/criterios-dgt" },
      { label: "Pistas de examen DGT", to: "/pistas-examen-dgt-vigo" },
    ],
    ctaTitle: "Súbete a la Z400",
    ctaText: "Carnet A2 con moto propia, equipación incluida y prácticas reales en Vigo. Pide tu presupuesto.",
  },

  "carnet-cuadriciclo-aml-vigo": {
    title: "Carnet AML en Vigo | Coche sin carnet desde los 15 años",
    description: "Carnet AML en Vigo: conduce un coche sin carnet desde los 15 años. Únicos en el sur de Galicia con cuadriciclo propio para prácticas y examen.",
    schemaName: "Curso para obtener el permiso AM con cuadriciclo ligero (AML) en Vigo",
    eyebrow: "AML · Únicos con cuadriciclo propio en el sur de Galicia",
    h1: "Carnet de cuadriciclo AML en Vigo – Conduce un coche sin carnet desde los 15 años",
    intro: [
      "Los **coches sin carnet** (cuadriciclos ligeros) permiten a los jóvenes moverse con autonomía **desde los 15 años**, protegidos de la lluvia y sin depender de nadie. Para conducirlos se necesita el **permiso AM validado para cuadriciclo (AML)**.",
      "En Autoescuelas Faro somos **los únicos del sur de Galicia con cuadriciclo ligero propio**: practicas y te examinas con el mismo vehículo que luego vas a conducir.",
    ],
    waMessage: "Hola, quiero un presupuesto para el carnet de cuadriciclo AML (coche sin carnet) en Vigo",
    images: [
      { src: "/assets/cuadriciclo-ligero-carnet-aml-vigo.webp", alt: "Cuadriciclo ligero de Autoescuelas Faro para el carnet AML en Vigo", caption: "Nuestro cuadriciclo ligero propio, único en el sur de Galicia", fit: "contain" },
      { src: "/assets/cuadriciclo-rojo-practicas-aml-vigo.webp", alt: "Cuadriciclo ligero rojo de prácticas de Autoescuelas Faro con placa L", caption: "El mismo cuadriciclo con el que practicas y te examinas", fit: "contain" },
    ],
    stats: [
      { icon: "users", k: "15 años", v: "edad mínima" },
      { icon: "car", k: "45 km/h", v: "velocidad máxima del cuadriciclo" },
      { icon: "badge", k: "Únicos", v: "con cuadriciclo propio en el sur de Galicia" },
      { icon: "file", k: "Sin", v: "examen de circulación" },
    ],
    sections: [
      {
        h2: "¿Qué es el carnet AML y qué puedes conducir?",
        bullets: [
          "El AML es el **permiso AM validado para cuadriciclos ligeros**: los conocidos **coches sin carnet** (Aixam, Ligier, Microcar, Citroën AMI...).",
          "Cuadriciclos ligeros de hasta **425 kg**, motor de hasta 6 kW y velocidad limitada a **45 km/h**.",
          "Incluye también los **ciclomotores** de 2 y 3 ruedas (permiso AM).",
          "Perfecto para estudiantes, desplazamientos por el rural y para quien quiere autonomía sin esperar a los 18.",
        ],
      },
      {
        h2: "Cómo son las pruebas del AML",
        bullets: [
          "**Teórico específico** del permiso AM: 20 preguntas, máximo 2 fallos.",
          "**Prueba de destreza en circuito cerrado** con el cuadriciclo: maniobras a baja velocidad.",
          "**Sin examen de circulación** en vías abiertas.",
          "Practicas con nuestro cuadriciclo propio, el mismo vehículo del examen.",
        ],
      },
      {
        h2: "¿Por qué sacar el AML con Faro?",
        bullets: [
          "Somos **los únicos del sur de Galicia con cuadriciclo ligero propio**: la mayoría de autoescuelas no pueden ofrecer esta formación.",
          "Practicas en **pistas propias**, sin tráfico, hasta dominar el vehículo.",
          "Más de 45 años de experiencia formando a los conductores más jóvenes.",
          "Gestionamos todo el papeleo con la Jefatura de Tráfico.",
        ],
      },
    ],
    centersNote: "Las prácticas con el cuadriciclo se realizan en Vigo, en nuestras pistas propias.",
    faq: [
      { q: "¿Cuánto cuesta el carnet de cuadriciclo AML en Vigo?", a: "Depende de las prácticas que necesites (suelen ser pocas). Solicita presupuesto sin compromiso por WhatsApp al 658 790 266 o llamando al 986 29 24 55." },
      { q: "¿A qué edad puedo conducir un coche sin carnet?", a: "Desde los 15 años, con el permiso AM validado para cuadriciclos ligeros (AML). Puedes matricularte y preparar la teórica un poco antes de cumplirlos." },
      { q: "¿Qué diferencia hay entre el AM y el AML?", a: "El AM básico habilita para ciclomotores de 2 y 3 ruedas. Para conducir un cuadriciclo ligero (coche sin carnet) la prueba práctica debe realizarse con un cuadriciclo: eso es el AML. En Faro tenemos cuadriciclo propio para ello." },
      { q: "¿Qué exámenes tiene el AML?", a: "Un teórico específico de 20 preguntas (máximo 2 fallos) y una prueba de destreza en circuito cerrado con el cuadriciclo. No hay examen de circulación en vías abiertas." },
      { q: "¿Con qué vehículo haré las prácticas y el examen?", a: "Con el cuadriciclo ligero propio de Autoescuelas Faro. Somos los únicos del sur de Galicia que disponemos de uno, así que practicarás y te examinarás con el mismo tipo de vehículo que vas a conducir." },
      { q: "¿Un coche sin carnet puede ir por autovía?", a: "No. Los cuadriciclos ligeros están limitados a 45 km/h y tienen prohibido circular por autopistas y autovías. Son ideales para ciudad y carreteras convencionales." },
      { q: "¿Cuánto se tarda en sacar el AML?", a: "Es de los permisos más rápidos: con la teórica preparada, en 3-6 semanas puedes tenerlo, según las fechas de examen disponibles en Vigo." },
      { q: "¿El AML me sirve luego para la moto o el coche?", a: "El AML incluye el permiso AM (ciclomotores). Para moto necesitarás el A1 (16 años) o A2 (18 años) y para coche el permiso B (18 años); la experiencia previa con el cuadriciclo te dará mucha soltura." },
    ],
    related: [
      { label: "Carnet A1 (125 cc)", to: "/carnet-a1-vigo" },
      { label: "Carnet de coche en Vigo", to: "/carnet-coche-vigo" },
      { label: "Todos los carnets de moto", to: "/carnet-moto-vigo" },
      { label: "Pistas de examen DGT", to: "/pistas-examen-dgt-vigo" },
    ],
    ctaTitle: "Autonomía desde los 15 años",
    ctaText: "Carnet AML con el único cuadriciclo de autoescuela del sur de Galicia. Pide tu presupuesto.",
  },
};

export const PERMIT_LANDING_SLUGS = Object.keys(PERMIT_LANDINGS);

// Mapping used by the home permit cards to deep-link each permit to its landing
export const LANDING_BY_CODE = {
  B: "/carnet-coche-vigo",
  AM: "/carnet-moto-vigo",
  A1: "/carnet-a1-vigo",
  A2: "/carnet-a2-vigo",
  A: "/carnet-moto-vigo",
  AML: "/carnet-cuadriciclo-aml-vigo",
  B96: "/carnet-remolque-vigo",
  "B+E": "/carnet-remolque-vigo",
  C: "/carnet-camion-vigo",
  "C+E": "/carnet-trailer-ce-vigo",
  D: "/carnet-autobus-vigo",
  CAP: "/curso-cap-vigo",
  Puntos: "/recuperacion-de-puntos-vigo",
};

export const LANDING_NAV = [
  { label: "Carnet de coche", to: "/carnet-coche-vigo" },
  { label: "Carnet de moto", to: "/carnet-moto-vigo" },
  { label: "Carnet A1 (moto 125)", to: "/carnet-a1-vigo" },
  { label: "Carnet A2", to: "/carnet-a2-vigo" },
  { label: "Cuadriciclo ligero AML", to: "/carnet-cuadriciclo-aml-vigo" },
  { label: "Carnet de camión", to: "/carnet-camion-vigo" },
  { label: "Carnet de tráiler (C+E)", to: "/carnet-trailer-ce-vigo" },
  { label: "Carnet de autobús", to: "/carnet-autobus-vigo" },
  { label: "Carnet de remolque (B96/B+E)", to: "/carnet-remolque-vigo" },
  { label: "Curso CAP", to: "/curso-cap-vigo" },
];
